export default () => ({
  user: {},
  userDetails: null,
});
